import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Sidebar from "../../../layout/Sidebar";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import toast from "../../../utils/toast";
import { getImageUrl } from "../../../utils/utils";

export default function EditMemberDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState("basic");
  const [alertMsg, setAlertMsg] = useState({ type: "", text: "" });
  const [uploadingPhotoIndex, setUploadingPhotoIndex] = useState(null);

  // Master Dropdown Data
  const [religions, setReligions] = useState([]);
  const [castes, setCastes] = useState([]);
  const [subCastes, setSubCastes] = useState([]);
  const [gotras, setGotras] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [birthCities, setBirthCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [maritalStatuses, setMaritalStatuses] = useState([]);
  const [lookingFors, setLookingFors] = useState([]);
  const [complexions, setComplexions] = useState([]);
  const [degrees, setDegrees] = useState([]);
  const [occupations, setOccupations] = useState([]);
  const [workingWiths, setWorkingWiths] = useState([]);
  const [diets, setDiets] = useState([]);
  const [languages, setLanguages] = useState([]);

  // Partner specific dropdowns
  const [partnerCastes, setPartnerCastes] = useState([]);
  const [partnerSubCastes, setPartnerSubCastes] = useState([]);
  const [partnerCities, setPartnerCities] = useState([]);

  const API_URL = (process.env.REACT_APP_BASE_URL_API || "http://localhost:8080").replace(/\/+$/, "");


  const heightOptions = (() => {
    const list = [];
    for (let ft = 3; ft <= 8; ft++) {
      let maxInches = ft === 8 ? 6 : 11;
      for (let inch = ft === 3 ? 1 : 0; inch <= maxInches; inch++) {
        if (inch === 0) {
          list.push({ label: `${ft} ft`, value: `${ft}.0` });
        } else {
          list.push({ label: `${ft} ft ${inch} in`, value: `${ft}.${inch}` });
        }
      }
    }
    return list;
  })();

  const weightOptions = Array.from({ length: 131 }, (_, i) => 20 + i);

  const healthItems = [
    "No Health Problems",
    "Average",
    "Weak",
    "Diabetes",
    "HIV Positive",
    "Low BP",
    "High BP",
    "Heart Ailments",
    "Others",
  ];

  const bloodGroupItems = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];

  const residenceTypes = [
    "Owned House",
    "Rented House",
    "Staying with Family",
    "Hostel / PG",
    "Company Accommodation",
    "Living Alone",
    "Living Abroad",
    "Other"
  ];

  const houseTypes = [
    "Independent House",
    "Apartment / Flat",
    "Bungalow",
    "Ancestral Home",
    "Government Quarters / Staff Housing",
    "Temporary / Rented House",
    "Other"
  ];

  const annualIncomeOptions = [
    { label: "1 Lakh", value: "100000" },
    { label: "2 Lakh", value: "200000" },
    { label: "3 Lakh", value: "300000" },
    { label: "4 Lakh", value: "400000" },
    { label: "5 Lakh", value: "500000" },
    { label: "6 Lakh", value: "600000" },
    { label: "7 Lakh", value: "700000" },
    { label: "8 Lakh", value: "800000" },
    { label: "9 Lakh", value: "900000" },
    { label: "10 Lakh", value: "1000000" },
    { label: "12 Lakh", value: "1200000" },
    { label: "15 Lakh", value: "1500000" },
    { label: "20 Lakh", value: "2000000" },
    { label: "25 Lakh", value: "2500000" },
    { label: "35 Lakh", value: "3500000" },
    { label: "50 Lakh", value: "5000000" },
    { label: "70 Lakh", value: "7000000" },
    { label: "1 Crore", value: "10000000" },
    { label: "Above 1 Crore", value: "Above 10000000" },
    { label: "Not Applicable", value: "Not Applicable" },
  ];

  const partnerIncomeOptions = [
    { label: "1 Lakh", value: "100000" },
    { label: "2 Lakh", value: "200000" },
    { label: "3 Lakh", value: "300000" },
    { label: "4 Lakh", value: "400000" },
    { label: "5 Lakh", value: "500000" },
    { label: "7 Lakh", value: "700000" },
    { label: "10 Lakh", value: "1000000" },
    { label: "15 Lakh", value: "1500000" },
    { label: "20 Lakh", value: "2000000" },
    { label: "25 Lakh", value: "2500000" },
    { label: "35 Lakh", value: "3500000" },
    { label: "50 Lakh", value: "5000000" },
    { label: "70 Lakh", value: "7000000" },
    { label: "1 Crore", value: "10000000" },
    { label: "Above 1 Crore", value: "Above 10000000" },
  ];

  const habitOptions = ["No", "Occasionally", "Yes", "Doesn't Matter"];

  const haveChildrenOptions = [
    "No",
    "Yes - Living together",
    "Yes - Living separately"
  ];

  const manglikOptions = [
    "Non Manglik",
    "Manglik",
    "Angshik Manglik",
    "Don't Know"
  ];

  const disabilityOptions = [
    "None",
    "Physical Disability"
  ];

  const familyTypeOptions = ["Joint", "Nuclear"];

  const familyValueOptions = ["Traditional", "Moderate", "Liberal", "Orthodox"];

  const partnerManagedByOptions = [
    "Open to All",
    "Self",
    "Parent / Guardian",
    "Sibling / Friend / Other"
  ];

  const [formData, setFormData] = useState({
    // Basic Info
    name: "",
    gender: "Male",
    dob: "",
    profile_for: "",
    marital_status: "",
    have_children: "No",
    height: "",
    weight: "",
    complexion: "",
    manglik: "Non Manglik",
    blood_group: "",
    disability: "None",
    health_information: "",
    drinking: "No",
    smoking: "No",
    about: "",

    // Contact & Location
    mobile: "",
    contact_no: "",
    email: "",
    contact_email: "",
    loc_state: "",
    loc_city: "",
    loc_pincode: "",
    loc_nationality: "",
    loc_residence_type: "",
    loc_house_type: "",

    // Religion & Astro
    religion: "",
    caste: "",
    sub_caste: "",
    gotra: "",
    diet: "",
    dosh: "No",
    birth_state: "",
    birth_city: "",
    birth_hour: "",
    birth_minute: "",
    birth_am: "AM",

    // Education & Career
    highest_degree: "",
    ug_degree: "",
    pg_degree: "",
    ug_college_name: "",
    pg_college_name: "",
    working_with: "",
    occupation: "",
    organization_name: "",
    annual_income: "",

    // Family
    family_type: "Nuclear",
    family_value: "Moderate",
    father_status: "",
    mother_status: "",
    no_of_brother: 0,
    married_brother: 0,
    no_of_sister: 0,
    married_sister: 0,

    // Partner Preferences
    partner_age_from: "",
    partner_age_to: "",
    partner_height_from: "",
    partner_height_to: "",
    partner_weight_from: "",
    partner_weight_to: "",
    partner_marital_status: "",
    partner_religion: "",
    partner_caste: "",
    partner_sub_caste: "",
    partner_gotra: "",
    partner_mother_tongue: "",
    partner_language: "",
    partner_country: "",
    partner_state: "",
    partner_city: "",
    partner_education: "",
    partner_occupation: "",
    partner_working_as: "",
    partner_income_from: "",
    partner_income_to: "",
    partner_diet: "",
    partner_drinking: "No",
    partner_smoking: "No",
    partner_complexion: "",
    partner_have_children: "No",
    partner_family_type: "",
    partner_family_value: "",

    // Photos
    photo: "",
    photo1: "",
    photo2: "",
    photo3: "",
    photo4: "",

    // Admin & Status Controls
    status: "Active",
    profileApproval: "Pending",
    photoApproval: "Pending",
    documentApproval: "Pending",
    step: 11
  });

  useEffect(() => {
    fetchMasterData();
    fetchUserDetails();
  }, [id]);

  const fetchMasterData = async () => {
    try {
      const [
        relRes, marRes, lookRes, compRes, degRes, occRes, workRes, dietRes,
        stateRes, countryRes, subCasteRes, gotraRes, casteRes, langRes
      ] = await Promise.allSettled([
        fetch(`${API_URL}/api/front/religion`).then(r => r.json()),
        fetch(`${API_URL}/api/front/marital-status`).then(r => r.json()),
        fetch(`${API_URL}/api/front/looking-for`).then(r => r.json()),
        fetch(`${API_URL}/api/front/complexion`).then(r => r.json()),
        fetch(`${API_URL}/api/front/education`).then(r => r.json()),
        fetch(`${API_URL}/api/front/occupation`).then(r => r.json()),
        fetch(`${API_URL}/api/front/working-with`).then(r => r.json()),
        fetch(`${API_URL}/api/front/diet`).then(r => r.json()),
        fetch(`${API_URL}/api/front/state`).then(r => r.json()),
        fetch(`${API_URL}/api/front/country`).then(r => r.json()),
        fetch(`${API_URL}/api/front/sub-caste`).then(r => r.json()),
        fetch(`${API_URL}/api/front/gotra`).then(r => r.json()),
        fetch(`${API_URL}/api/front/caste`).then(r => r.json()),
        fetch(`${API_URL}/api/front/language`).then(r => r.json()),
      ]);

      if (relRes.value?.data) setReligions(relRes.value.data);
      if (marRes.value?.data) setMaritalStatuses(marRes.value.data);
      if (lookRes.value?.data) setLookingFors(lookRes.value.data);
      if (compRes.value?.data) setComplexions(compRes.value.data);
      if (degRes.value?.data) setDegrees(degRes.value.data);
      if (occRes.value?.data) setOccupations(occRes.value.data);
      if (workRes.value?.data) setWorkingWiths(workRes.value.data);
      if (dietRes.value?.data) setDiets(dietRes.value.data);
      if (stateRes.value?.data) setStates(stateRes.value.data);
      if (countryRes.value?.data) setCountries(countryRes.value.data);
      if (subCasteRes.value?.data && subCasteRes.value.data.length > 0) setSubCastes(subCasteRes.value.data);
      if (gotraRes.value?.data && gotraRes.value.data.length > 0) setGotras(gotraRes.value.data);
      if (casteRes.value?.data && casteRes.value.data.length > 0) setCastes(casteRes.value.data);
      if (langRes.value?.data && langRes.value.data.length > 0) setLanguages(langRes.value.data);
    } catch (e) {
      console.error("Master data fetch error:", e);
    }
  };

  const fetchCastesByReligion = async (religionId) => {
    try {
      const url = religionId
        ? `${API_URL}/api/front/caste/${religionId}`
        : `${API_URL}/api/front/caste`;
      const res = await fetch(url);
      const data = await res.json();
      if (data.status && data.data && data.data.length > 0) {
        setCastes(data.data);
      } else {
        const allRes = await fetch(`${API_URL}/api/front/caste`);
        const allData = await allRes.json();
        if (allData.status && allData.data) {
          setCastes(allData.data);
        }
      }
    } catch (e) {
      console.error("Error fetching castes:", e);
    }
  };

  const fetchPartnerCastes = async (religionId) => {
    try {
      const url = religionId
        ? `${API_URL}/api/front/caste/${religionId}`
        : `${API_URL}/api/front/caste`;
      const res = await fetch(url);
      const data = await res.json();
      if (data.status && data.data && data.data.length > 0) {
        setPartnerCastes(data.data);
      } else {
        const allRes = await fetch(`${API_URL}/api/front/caste`);
        const allData = await allRes.json();
        if (allData.status && allData.data) {
          setPartnerCastes(allData.data);
        }
      }
    } catch (e) {
      console.error("Error fetching partner castes:", e);
    }
  };

  const fetchSubCastesByCaste = async (casteId) => {
    try {
      if (casteId) {
        const res = await fetch(`${API_URL}/api/front/sub-caste/${casteId}`);
        const data = await res.json();
        if (data.status && data.data && data.data.length > 0) {
          setSubCastes(data.data);
          return;
        }
      }
      const allRes = await fetch(`${API_URL}/api/front/sub-caste`);
      const allData = await allRes.json();
      if (allData.status && allData.data) {
        setSubCastes(allData.data);
      }
    } catch (e) {
      console.error("Error fetching subcastes:", e);
    }
  };

  const fetchPartnerSubCastes = async (casteId) => {
    try {
      if (casteId) {
        const res = await fetch(`${API_URL}/api/front/sub-caste/${casteId}`);
        const data = await res.json();
        if (data.status && data.data && data.data.length > 0) {
          setPartnerSubCastes(data.data);
          return;
        }
      }
      const allRes = await fetch(`${API_URL}/api/front/sub-caste`);
      const allData = await allRes.json();
      if (allData.status && allData.data) {
        setPartnerSubCastes(allData.data);
      }
    } catch (e) {
      console.error("Error fetching partner subcastes:", e);
    }
  };

  const fetchGotrasByReligion = async (religionId) => {
    try {
      if (religionId) {
        const res = await fetch(`${API_URL}/api/front/gotra/${religionId}`);
        const data = await res.json();
        if (data.status && data.data && data.data.length > 0) {
          setGotras(data.data);
          return;
        }
      }
      const allRes = await fetch(`${API_URL}/api/front/gotra`);
      const allData = await allRes.json();
      if (allData.status && allData.data) {
        setGotras(allData.data);
      }
    } catch (e) {
      console.error("Error fetching gotras:", e);
    }
  };

  const fetchCitiesByState = async (stateId, target = "loc") => {
    try {
      const url = stateId
        ? `${API_URL}/api/front/city/${stateId}`
        : `${API_URL}/api/front/city`;
      const res = await fetch(url);
      const data = await res.json();
      const list = data.status && data.data && data.data.length > 0 ? data.data : [];
      if (target === "loc") setCities(list);
      else if (target === "birth") setBirthCities(list);
      else if (target === "partner") setPartnerCities(list);
    } catch (e) {
      console.error("Error fetching cities:", e);
    }
  };

  const fetchUserDetails = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("adminToken");
      const res = await fetch(`${API_URL}/api/admin/user-list/${id}`, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      const result = await res.json();
      if (result.status && result.data) {
        const u = result.data;
        const formattedDob = u.dob ? new Date(u.dob).toISOString().split("T")[0] : "";

        const relId = u.religion?._id || u.religion || "";
        const casteId = u.caste?._id || u.caste || "";
        const subCasteId = u.sub_caste?._id || u.sub_caste || "";
        const gotraId = u.gotra?._id || u.gotra || "";
        const stateId = u.loc_state?._id || u.loc_state || "";
        const cityId = u.loc_city?._id || u.loc_city || "";
        const birthStateId = u.birth_state?._id || u.birth_state || "";
        const birthCityId = u.birth_city?._id || u.birth_city || "";

        const partnerRelId = u.partner_religion?._id || u.partner_religion || "";
        const partnerCasteId = u.partner_caste?._id || u.partner_caste || "";
        const partnerSubCasteId = u.partner_sub_caste?._id || u.partner_sub_caste || "";
        const partnerStateId = u.partner_state?._id || u.partner_state || "";

        let partnerMaritalStatusVal = "";
        if (Array.isArray(u.partner_marital_status) && u.partner_marital_status.length > 0) {
          partnerMaritalStatusVal = u.partner_marital_status.map(m => m?._id || m).join(",");
        } else if (u.partner_marital_status?._id || u.partner_marital_status) {
          partnerMaritalStatusVal = u.partner_marital_status._id || u.partner_marital_status;
        }

        let manglikVal = u.manglik || "Non Manglik";
        if (manglikVal === "No") manglikVal = "Non Manglik";
        else if (manglikVal === "Yes") manglikVal = "Manglik";
        else if (manglikVal === "Partial / Anshik") manglikVal = "Angshik Manglik";

        let disabilityVal = u.disability || "None";
        if (disabilityVal === "No") disabilityVal = "None";
        else if (disabilityVal === "Yes") disabilityVal = "Physical Disability";

        let haveChildrenVal = u.have_children || "No";
        if (haveChildrenVal === "Yes Living Together") haveChildrenVal = "Yes - Living together";
        else if (haveChildrenVal === "Yes Not Living Together") haveChildrenVal = "Yes - Living separately";

        let partnerHaveChildrenVal = u.partner_have_children || "No";
        if (partnerHaveChildrenVal === "Yes Living Together") partnerHaveChildrenVal = "Yes - Living together";
        else if (partnerHaveChildrenVal === "Yes Not Living Together") partnerHaveChildrenVal = "Yes - Living separately";

        let heightVal = u.height != null ? String(u.height).trim() : "";
        if (/^[3-8]$/.test(heightVal)) heightVal = `${heightVal}.0`;

        let partnerHeightFromVal = u.partner_height_from != null ? String(u.partner_height_from).trim() : "";
        if (/^[3-8]$/.test(partnerHeightFromVal)) partnerHeightFromVal = `${partnerHeightFromVal}.0`;

        let partnerHeightToVal = u.partner_height_to != null ? String(u.partner_height_to).trim() : "";
        if (/^[3-8]$/.test(partnerHeightToVal)) partnerHeightToVal = `${partnerHeightToVal}.0`;

        let resTypeVal = u.loc_residence_type || "";
        if (resTypeVal === "Owned") resTypeVal = "Owned House";
        else if (resTypeVal === "Rented") resTypeVal = "Rented House";
        else if (resTypeVal === "Company Provided") resTypeVal = "Company Accommodation";

        let familyVal = u.family_value || "Moderate";
        let partnerFamilyVal = u.partner_family_value || "";

        setFormData({
          name: u.name || "",
          gender: u.gender || "Male",
          dob: formattedDob,
          profile_for: u.profile_for?._id || u.profile_for || "",
          marital_status: u.marital_status?._id || u.marital_status || "",
          have_children: haveChildrenVal,
          height: heightVal,
          weight: u.weight != null ? String(u.weight) : "",
          complexion: u.complexion?._id || u.complexion || "",
          manglik: manglikVal,
          blood_group: u.blood_group || "",
          disability: disabilityVal,
          health_information: u.health_information || "",
          drinking: u.drinking || "No",
          smoking: u.smoking || "No",
          about: u.about || "",

          mobile: u.mobile || "",
          contact_no: u.contact_no || "",
          email: u.email || "",
          contact_email: u.contact_email || "",
          loc_state: stateId,
          loc_city: cityId,
          loc_pincode: u.loc_pincode || "",
          loc_nationality: u.loc_nationality?._id || u.loc_nationality || "",
          loc_residence_type: resTypeVal,
          loc_house_type: u.loc_house_type || "",

          religion: relId,
          caste: casteId,
          sub_caste: subCasteId,
          gotra: gotraId,
          diet: u.diet?._id || u.diet || "",
          dosh: u.dosh || "No",
          birth_state: birthStateId,
          birth_city: birthCityId,
          birth_hour: u.birth_hour || "",
          birth_minute: u.birth_minute || "",
          birth_am: u.birth_am || "AM",

          highest_degree: u.highest_degree?._id || u.highest_degree || "",
          ug_degree: u.ug_degree?._id || u.ug_degree || "",
          pg_degree: u.pg_degree?._id || u.pg_degree || "",
          ug_college_name: u.ug_college_name || "",
          pg_college_name: u.pg_college_name || "",
          working_with: u.working_with?._id || u.working_with || "",
          occupation: u.occupation?._id || u.occupation || "",
          organization_name: u.organization_name || "",
          annual_income: u.annual_income || "",

          family_type: u.family_type || "Nuclear",
          family_value: familyVal,
          father_status: u.father_status || "",
          mother_status: u.mother_status || "",
          no_of_brother: u.no_of_brother || 0,
          married_brother: u.married_brother || 0,
          no_of_sister: u.no_of_sister || 0,
          married_sister: u.married_sister || 0,

          partner_age_from: u.partner_age_from || "",
          partner_age_to: u.partner_age_to || "",
          partner_height_from: partnerHeightFromVal,
          partner_height_to: partnerHeightToVal,
          partner_weight_from: u.partner_weight_from || "",
          partner_weight_to: u.partner_weight_to || "",
          partner_marital_status: partnerMaritalStatusVal,
          partner_religion: partnerRelId,
          partner_caste: partnerCasteId,
          partner_sub_caste: partnerSubCasteId,
          partner_gotra: u.partner_gotra?._id || u.partner_gotra || "",
          partner_mother_tongue: u.partner_mother_tongue?._id || u.partner_mother_tongue || "",
          partner_language: u.partner_language?._id || u.partner_language || "",
          partner_country: u.partner_country?._id || u.partner_country || "",
          partner_state: partnerStateId,
          partner_city: u.partner_city?._id || u.partner_city || "",
          partner_education: u.partner_education?._id || u.partner_education || "",
          partner_occupation: u.partner_occupation?._id || u.partner_occupation || "",
          partner_working_as: u.partner_working_as?._id || u.partner_working_as || "",
          partner_income_from: u.partner_income_from != null ? String(u.partner_income_from) : "",
          partner_income_to: u.partner_income_to != null ? String(u.partner_income_to) : "",
          partner_diet: u.partner_diet?._id || u.partner_diet || "",
          partner_drinking: u.partner_drinking || "No",
          partner_smoking: u.partner_smoking || "No",
          partner_complexion: u.partner_complexion?._id || u.partner_complexion || "",
          partner_have_children: partnerHaveChildrenVal,
          partner_family_type: u.partner_family_type || "",
          partner_family_value: partnerFamilyVal,
          partner_managed_by: u.partner_managed_by || "",

          photo: u.photo || "",
          photo1: u.photo1 || "",
          photo2: u.photo2 || "",
          photo3: u.photo3 || "",
          photo4: u.photo4 || "",

          status: u.status || "Active",
          profileApproval: u.profileApproval || "Pending",
          photoApproval: u.photoApproval || "Pending",
          documentApproval: u.documentApproval || "Pending",
          step: u.step != null ? u.step : 5
        });

        if (relId) {
          fetchCastesByReligion(relId);
          fetchGotrasByReligion(relId);
        }
        if (casteId) fetchSubCastesByCaste(casteId);
        if (stateId) fetchCitiesByState(stateId, "loc");
        if (birthStateId) fetchCitiesByState(birthStateId, "birth");

        if (partnerRelId) fetchPartnerCastes(partnerRelId);
        if (partnerCasteId) fetchPartnerSubCastes(partnerCasteId);
        if (partnerStateId) fetchCitiesByState(partnerStateId, "partner");
      } else {
        toast.showError(result.message || "Failed to load user details");
      }
    } catch (e) {
      toast.showError("Error loading user data");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const updated = { ...prev, [name]: value };
      if (name === "religion") {
        updated.caste = "";
        updated.sub_caste = "";
        updated.gotra = "";
      }
      if (name === "caste") {
        updated.sub_caste = "";
      }
      if (name === "loc_state") {
        updated.loc_city = "";
      }
      if (name === "birth_state") {
        updated.birth_city = "";
      }
      if (name === "partner_religion") {
        updated.partner_caste = "";
        updated.partner_sub_caste = "";
      }
      if (name === "partner_caste") {
        updated.partner_sub_caste = "";
      }
      if (name === "partner_state") {
        updated.partner_city = "";
      }
      return updated;
    });

    if (name === "religion") {
      fetchCastesByReligion(value);
      fetchGotrasByReligion(value);
      setSubCastes([]);
    }
    if (name === "caste") {
      fetchSubCastesByCaste(value);
    }
    if (name === "loc_state") {
      fetchCitiesByState(value, "loc");
    }
    if (name === "birth_state") {
      fetchCitiesByState(value, "birth");
    }
    if (name === "partner_religion") {
      fetchPartnerCastes(value);
      setPartnerSubCastes([]);
    }
    if (name === "partner_caste") {
      fetchPartnerSubCastes(value);
    }
    if (name === "partner_state") {
      fetchCitiesByState(value, "partner");
    }
  };

  const handlePhotoUpload = async (e, photoKey, index) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploadingPhotoIndex(index);
    try {
      const uploadData = new FormData();
      uploadData.append("file", file);

      const res = await fetch(`${API_URL}/api/upload`, {
        method: "POST",
        body: uploadData
      });
      const data = await res.json();

      if (data.status && (data.data?.key || data.data?.url)) {
        const uploadedKey = data.data.key || data.data.url;
        setFormData(prev => ({
          ...prev,
          [photoKey]: uploadedKey
        }));
        toast.showSuccess(`Photo ${index === 0 ? "Main" : index} uploaded successfully`);
      } else {
        toast.showError(data.message || "Failed to upload photo");
      }
    } catch (err) {
      console.error("Photo upload error:", err);
      toast.showError("Error uploading photo to server");
    } finally {
      setUploadingPhotoIndex(null);
      e.target.value = "";
    }
  };

  const handlePhotoDelete = async (photoKey, index) => {
    if (!window.confirm(`Are you sure you want to delete Photo ${index === 0 ? "Main" : index}?`)) {
      return;
    }

    try {
      const token = localStorage.getItem("adminToken");
      const res = await fetch(`${API_URL}/api/admin/user-list/${id}/photo/${index}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });
      const data = await res.json();
      if (data.status) {
        setFormData(prev => ({
          ...prev,
          [photoKey]: ""
        }));
        toast.showSuccess(`Photo ${index === 0 ? "Main" : index} deleted successfully`);
      } else {
        toast.showError(data.message || "Failed to delete photo");
      }
    } catch (err) {
      console.error("Photo delete error:", err);
      toast.showError("Error deleting photo");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setAlertMsg({ type: "", text: "" });

    try {
      const token = localStorage.getItem("adminToken");
      const cleanMobile = formData.mobile ? String(formData.mobile).replace(/\D/g, "").slice(0, 10) : "";
      const cleanContactNo = formData.contact_no ? String(formData.contact_no).replace(/\D/g, "").slice(0, 10) : "";
      const cleanEmail = formData.email ? String(formData.email).toLowerCase().trim() : "";
      const cleanContactEmail = formData.contact_email ? String(formData.contact_email).toLowerCase().trim() : "";

      const payload = {
        ...formData,
        mobile: cleanMobile,
        contact_no: cleanContactNo ? Number(cleanContactNo) : null,
        email: cleanEmail,
        contact_email: cleanContactEmail
      };

      const response = await fetch(`${API_URL}/api/admin/user-list/update/${id}`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();
      if (result.status) {
        setAlertMsg({ type: "success", text: result.message || "Member details updated successfully!" });
        toast.showSuccess(result.message || "Member details updated successfully!");
        setTimeout(() => {
          navigate(`/user/view-member/${id}`);
        }, 1200);
      } else {
        setAlertMsg({ type: "danger", text: result.message || "Failed to update member" });
        toast.showError(result.message || "Failed to update member");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (err) {
      setAlertMsg({ type: "danger", text: "Server connection error during update. Please try again." });
      toast.showError("Server connection error during update");
    } finally {
      setSaving(false);
    }
  };

  const tabButtonStyle = (tabName, icon, label) => {
    const isActive = activeTab === tabName;
    return (
      <button
        type="button"
        onClick={() => setActiveTab(tabName)}
        style={{
          padding: "10px 18px",
          fontSize: "13px",
          fontWeight: "600",
          borderRadius: "30px",
          border: isActive ? "1px solid #b82e66" : "1px solid #e2e8f0",
          background: isActive
            ? "linear-gradient(135deg, #b82e66 0%, #8e1948 100%)"
            : "#ffffff",
          color: isActive ? "#ffffff" : "#4a5568",
          cursor: "pointer",
          transition: "all 0.25s ease",
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          boxShadow: isActive ? "0 4px 12px rgba(184, 46, 102, 0.25)" : "0 1px 3px rgba(0,0,0,0.04)"
        }}
      >
        <i className={icon} style={{ fontSize: "14px", color: isActive ? "#ffffff" : "#b82e66" }}></i>
        <span>{label}</span>
      </button>
    );
  };

  const photoSlots = [
    { key: "photo", label: "Main Profile Photo", index: 0 },
    { key: "photo1", label: "Photo 1", index: 1 },
    { key: "photo2", label: "Photo 2", index: 2 },
    { key: "photo3", label: "Photo 3", index: 3 },
    { key: "photo4", label: "Photo 4", index: 4 }
  ];

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="Edit Member Details" />

        <div className="right_col" role="main" style={{ minHeight: "100vh", padding: "20px 25px", background: "#f4f6f9" }}>
          <div className="clearfix" />

          {/* Top Bar Header */}
          <div className="row mb-3 align-items-center">
            <div className="col-md-6 col-sm-6">
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <div style={{ width: "36px", height: "36px", borderRadius: "8px", background: "linear-gradient(135deg, #b82e66 0%, #8e1948 100%)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff" }}>
                  <i className="fa fa-pencil" style={{ fontSize: "18px" }}></i>
                </div>
                <div>
                  <h3 style={{ margin: 0, fontWeight: "700", color: "#2A3F54", fontSize: "20px" }}>
                    Edit Member Profile
                  </h3>
                  <span style={{ fontSize: "12px", color: "#6c757d" }}>Modify member details, partner preferences, photos & status</span>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 text-end">
              <Link to={`/user/view-member/${id}`} className="btn btn-sm me-2" style={{ borderRadius: "20px", background: "#ffffff", border: "1px solid #cbd5e1", color: "#475569", fontWeight: "600", padding: "6px 16px" }}>
                <i className="fa fa-eye me-1"></i> View Profile
              </Link>
              <Link to="/user/all-member" className="btn btn-sm" style={{ borderRadius: "20px", background: "#f1f5f9", border: "1px solid #cbd5e1", color: "#334155", fontWeight: "600", padding: "6px 16px" }}>
                <i className="fa fa-list me-1"></i> All Members
              </Link>
            </div>
          </div>

          {alertMsg.text && (
            <div className={`alert alert-${alertMsg.type} alert-dismissible fade show`} role="alert" style={{ fontSize: "14px", fontWeight: "500", borderRadius: "10px", border: "none", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
              <i className={`fa ${alertMsg.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-triangle'} me-2`}></i>
              {alertMsg.text}
              <button type="button" className="btn-close" onClick={() => setAlertMsg({ type: "", text: "" })} style={{ float: "right", background: "none", border: "none", fontSize: "16px", cursor: "pointer" }}>×</button>
            </div>
          )}

          {loading ? (
            <div className="x_panel text-center p-5" style={{ borderRadius: "12px", border: "none", boxShadow: "0 4px 15px rgba(0,0,0,0.05)" }}>
              <div className="spinner-border mb-3" style={{ color: "#b82e66", width: "3rem", height: "3rem" }} role="status"></div>
              <h4 style={{ color: "#2A3F54", fontWeight: "600" }}>Loading member form data...</h4>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="x_panel shadow-sm" style={{ borderRadius: "14px", border: "none", background: "#ffffff", padding: "20px 25px" }}>
                {/* Modern Brand Tabs Navigation */}
                <div className="mb-4 d-flex flex-wrap gap-2 pb-3" style={{ borderBottom: "1px solid #f1f5f9" }}>
                  {tabButtonStyle('basic', 'fa fa-user', 'Basic Info')}
                  {tabButtonStyle('contact', 'fa fa-phone', 'Contact & Location')}
                  {tabButtonStyle('religion', 'fa fa-moon-o', 'Religion & Horoscope')}
                  {tabButtonStyle('education', 'fa fa-graduation-cap', 'Education & Career')}
                  {tabButtonStyle('family', 'fa fa-users', 'Family Details')}
                  {tabButtonStyle('partner', 'fa fa-heart', 'Partner Preferences')}
                  {tabButtonStyle('photos', 'fa fa-picture-o', 'Photos Management')}
                  {tabButtonStyle('admin', 'fa fa-shield', 'Admin & Controls')}
                </div>

                <div className="x_content p-2">
                  {/* TAB 1: BASIC INFO */}
                  {activeTab === "basic" && (
                    <div className="row g-3">
                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">Full Name <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Gender</label>
                        <select className="form-control" name="gender" value={formData.gender} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Date of Birth</label>
                        <input type="date" className="form-control" name="dob" value={formData.dob} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Profile Created For</label>
                        <select className="form-control" name="profile_for" value={formData.profile_for} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Option</option>
                          {lookingFors.map(l => <option key={l._id} value={l._id}>{l.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Marital Status</label>
                        <select className="form-control" name="marital_status" value={formData.marital_status} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Status</option>
                          {maritalStatuses.map(m => <option key={m._id} value={m._id}>{m.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Have Children?</label>
                        <select className="form-control" name="have_children" value={formData.have_children} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          {haveChildrenOptions.map(hc => (
                            <option key={hc} value={hc}>{hc}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Height</label>
                        <select className="form-control" name="height" value={formData.height} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Height</option>
                          {heightOptions.map(h => (
                            <option key={h.value} value={h.value}>{h.label}</option>
                          ))}
                          {formData.height && !heightOptions.some(h => String(h.value) === String(formData.height)) && (
                            <option value={formData.height}>{formData.height}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Weight (kg)</label>
                        <select className="form-control" name="weight" value={formData.weight} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Weight</option>
                          {weightOptions.map(wt => (
                            <option key={wt} value={String(wt)}>{wt} kg</option>
                          ))}
                          {formData.weight && !weightOptions.some(wt => String(wt) === String(formData.weight)) && (
                            <option value={formData.weight}>{formData.weight} kg</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Complexion</label>
                        <select className="form-control" name="complexion" value={formData.complexion} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Complexion</option>
                          {complexions.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Blood Group</label>
                        <select className="form-control" name="blood_group" value={formData.blood_group} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Blood Group</option>
                          {bloodGroupItems.map(bg => (
                            <option key={bg} value={bg}>{bg}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Manglik</label>
                        <select className="form-control" name="manglik" value={formData.manglik} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          {manglikOptions.map(m => (
                            <option key={m} value={m}>{m}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Disability</label>
                        <select className="form-control" name="disability" value={formData.disability} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          {disabilityOptions.map(d => (
                            <option key={d} value={d}>{d}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Drinking Habit</label>
                        <select className="form-control" name="drinking" value={formData.drinking} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          {habitOptions.map(h => (
                            <option key={h} value={h}>{h}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Smoking Habit</label>
                        <select className="form-control" name="smoking" value={formData.smoking} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          {habitOptions.map(h => (
                            <option key={h} value={h}>{h}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-12 form-group">
                        <label className="fw-bold text-dark">Health Information (if any)</label>
                        <select className="form-control" name="health_information" value={formData.health_information} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Health Information</option>
                          {healthItems.map(item => (
                            <option key={item} value={item}>{item}</option>
                          ))}
                          {formData.health_information && !healthItems.includes(formData.health_information) && (
                            <option value={formData.health_information}>{formData.health_information}</option>
                          )}
                        </select>
                      </div>

                      <div className="col-md-12 form-group">
                        <label className="fw-bold text-dark">About Me</label>
                        <textarea className="form-control" rows="3" name="about" value={formData.about} onChange={handleChange} placeholder="Write brief profile description..." style={{ borderRadius: "8px", padding: "10px 12px" }} />
                      </div>
                    </div>
                  )}

                  {/* TAB 2: CONTACT & LOCATION */}
                  {activeTab === "contact" && (
                    <div className="row g-3">
                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">Login Mobile Number (10 Digits)</label>
                        <input
                          type="text"
                          className="form-control"
                          name="mobile"
                          value={formData.mobile}
                          onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                            setFormData(prev => ({ ...prev, mobile: val }));
                          }}
                          placeholder="Enter 10-digit login mobile"
                          maxLength={10}
                          style={{ borderRadius: "8px", padding: "8px 12px" }}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">Contact Phone Number (Alternate)</label>
                        <input
                          type="text"
                          className="form-control"
                          name="contact_no"
                          value={formData.contact_no}
                          onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                            setFormData(prev => ({ ...prev, contact_no: val }));
                          }}
                          placeholder="Enter alternate contact number"
                          maxLength={10}
                          style={{ borderRadius: "8px", padding: "8px 12px" }}
                        />
                      </div>

                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">Login Email</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Enter login email"
                          style={{ borderRadius: "8px", padding: "8px 12px" }}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">Contact Email (Alternate)</label>
                        <input
                          type="email"
                          className="form-control"
                          name="contact_email"
                          value={formData.contact_email}
                          onChange={handleChange}
                          placeholder="Enter alternate contact email"
                          style={{ borderRadius: "8px", padding: "8px 12px" }}
                        />
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Nationality / Country</label>
                        <select className="form-control" name="loc_nationality" value={formData.loc_nationality} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Country</option>
                          {countries.map(cnt => <option key={cnt._id} value={cnt._id}>{cnt.name}</option>)}
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">State</label>
                        <select className="form-control" name="loc_state" value={formData.loc_state} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select State</option>
                          {states.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">City</label>
                        <select className="form-control" name="loc_city" value={formData.loc_city} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select City</option>
                          {cities.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
                          {formData.loc_city && !cities.some(c => c._id === formData.loc_city) && (
                            <option value={formData.loc_city}>Selected City</option>
                          )}
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Pincode</label>
                        <input type="text" className="form-control" name="loc_pincode" value={formData.loc_pincode} onChange={handleChange} placeholder="e.g. 226001" maxLength={6} style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Residence Type</label>
                        <select className="form-control" name="loc_residence_type" value={formData.loc_residence_type} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Residence Type</option>
                          {residenceTypes.map(rt => (
                            <option key={rt} value={rt}>{rt}</option>
                          ))}
                          {formData.loc_residence_type && !residenceTypes.includes(formData.loc_residence_type) && (
                            <option value={formData.loc_residence_type}>{formData.loc_residence_type}</option>
                          )}
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Permanent House Type</label>
                        <select className="form-control" name="loc_house_type" value={formData.loc_house_type} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Permanent House Type</option>
                          {houseTypes.map(ht => (
                            <option key={ht} value={ht}>{ht}</option>
                          ))}
                          {formData.loc_house_type && !houseTypes.includes(formData.loc_house_type) && (
                            <option value={formData.loc_house_type}>{formData.loc_house_type}</option>
                          )}
                        </select>
                      </div>
                    </div>
                  )}

                  {/* TAB 3: RELIGION & HOROSCOPE */}
                  {activeTab === "religion" && (
                    <div className="row g-3">
                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">Religion</label>
                        <select className="form-control" name="religion" value={formData.religion} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Religion</option>
                          {religions.map(r => <option key={r._id} value={r._id}>{r.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">Caste</label>
                        <select className="form-control" name="caste" value={formData.caste} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Caste</option>
                          {castes.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Sub Caste</label>
                        <select className="form-control" name="sub_caste" value={formData.sub_caste} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Sub Caste</option>
                          {subCastes.map(sc => <option key={sc._id} value={sc._id}>{sc.name}</option>)}
                          {formData.sub_caste && !subCastes.some(sc => sc._id === formData.sub_caste) && (
                            <option value={formData.sub_caste}>{formData.sub_caste}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Gotra</label>
                        <select className="form-control" name="gotra" value={formData.gotra} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Gotra</option>
                          {gotras.map(g => <option key={g._id} value={g._id}>{g.name}</option>)}
                          {formData.gotra && !gotras.some(g => g._id === formData.gotra) && (
                            <option value={formData.gotra}>{formData.gotra}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Diet</label>
                        <select className="form-control" name="diet" value={formData.diet} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Diet</option>
                          {diets.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
                        </select>
                      </div>

                      <div className="col-md-12 mt-3 pt-2" style={{ borderTop: "1px dashed #e2e8f0" }}>
                        <h5 className="fw-bold" style={{ color: "#b82e66", fontSize: "14px" }}>
                          <i className="fa fa-star-o me-1"></i> Horoscope & Astrology Details
                        </h5>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Birth State</label>
                        <select className="form-control" name="birth_state" value={formData.birth_state} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Birth State</option>
                          {states.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Birth City</label>
                        <select className="form-control" name="birth_city" value={formData.birth_city} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Birth City</option>
                          {birthCities.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
                          {formData.birth_city && !birthCities.some(c => c._id === formData.birth_city) && (
                            <option value={formData.birth_city}>Selected City</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Kundali Dosh</label>
                        <select className="form-control" name="dosh" value={formData.dosh} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="No">No</option>
                          <option value="Yes">Yes</option>
                          <option value="Don't Know">Don't Know</option>
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-4 form-group">
                        <label className="fw-bold text-dark">Birth Hour (0-12)</label>
                        <input type="number" className="form-control" name="birth_hour" value={formData.birth_hour} onChange={handleChange} placeholder="e.g. 10" min="0" max="12" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>
                      <div className="col-md-4 col-sm-4 form-group">
                        <label className="fw-bold text-dark">Birth Minute (0-59)</label>
                        <input type="number" className="form-control" name="birth_minute" value={formData.birth_minute} onChange={handleChange} placeholder="e.g. 30" min="0" max="59" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>
                      <div className="col-md-4 col-sm-4 form-group">
                        <label className="fw-bold text-dark">AM / PM</label>
                        <select className="form-control" name="birth_am" value={formData.birth_am} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="AM">AM</option>
                          <option value="PM">PM</option>
                        </select>
                      </div>
                    </div>
                  )}

                  {/* TAB 4: EDUCATION & CAREER */}
                  {activeTab === "education" && (
                    <div className="row g-3">
                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">Highest Degree</label>
                        <select className="form-control" name="highest_degree" value={formData.highest_degree} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Degree</option>
                          {degrees.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Undergraduate (UG) Degree</label>
                        <select className="form-control" name="ug_degree" value={formData.ug_degree} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select UG Degree</option>
                          {degrees.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Postgraduate (PG) Degree</label>
                        <select className="form-control" name="pg_degree" value={formData.pg_degree} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select PG Degree</option>
                          {degrees.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
                        </select>
                      </div>

                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">UG College / Institute Name</label>
                        <input type="text" className="form-control" name="ug_college_name" value={formData.ug_college_name} onChange={handleChange} placeholder="e.g. Delhi University" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>
                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">PG College / Institute Name</label>
                        <input type="text" className="form-control" name="pg_college_name" value={formData.pg_college_name} onChange={handleChange} placeholder="e.g. IIM / IIT" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Employed In (Working With)</label>
                        <select className="form-control" name="working_with" value={formData.working_with} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Sector</option>
                          {workingWiths.map(w => <option key={w._id} value={w._id}>{w.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Occupation</label>
                        <select className="form-control" name="occupation" value={formData.occupation} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Occupation</option>
                          {occupations.map(o => <option key={o._id} value={o._id}>{o.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Annual Income</label>
                        <select className="form-control" name="annual_income" value={formData.annual_income} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Annual Income</option>
                          {annualIncomeOptions.map(inc => (
                            <option key={inc.value} value={inc.value}>{inc.label}</option>
                          ))}
                          {formData.annual_income && !annualIncomeOptions.some(inc => String(inc.value) === String(formData.annual_income)) && (
                            <option value={formData.annual_income}>{formData.annual_income}</option>
                          )}
                        </select>
                      </div>

                      <div className="col-md-12 form-group">
                        <label className="fw-bold text-dark">Company / Organization Name</label>
                        <input type="text" className="form-control" name="organization_name" value={formData.organization_name} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>
                    </div>
                  )}

                  {/* TAB 5: FAMILY DETAILS */}
                  {activeTab === "family" && (
                    <div className="row g-3">
                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">Family Type</label>
                        <select className="form-control" name="family_type" value={formData.family_type} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="Joint">Joint</option>
                          <option value="Nuclear">Nuclear</option>
                        </select>
                      </div>
                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">Family Value</label>
                        <select className="form-control" name="family_value" value={formData.family_value} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="Traditional">Traditional</option>
                          <option value="Moderate">Moderate</option>
                          <option value="Liberal">Liberal</option>
                        </select>
                      </div>

                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">Father's Status / Occupation</label>
                        <input type="text" className="form-control" name="father_status" value={formData.father_status} onChange={handleChange} placeholder="e.g. Business / Retired / Government Employee" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>
                      <div className="col-md-6 col-sm-12 form-group">
                        <label className="fw-bold text-dark">Mother's Status / Occupation</label>
                        <input type="text" className="form-control" name="mother_status" value={formData.mother_status} onChange={handleChange} placeholder="e.g. Homemaker / Teacher" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>

                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Total Brothers</label>
                        <input type="number" className="form-control" name="no_of_brother" value={formData.no_of_brother} onChange={handleChange} min="0" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Married Brothers</label>
                        <input type="number" className="form-control" name="married_brother" value={formData.married_brother} onChange={handleChange} min="0" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Total Sisters</label>
                        <input type="number" className="form-control" name="no_of_sister" value={formData.no_of_sister} onChange={handleChange} min="0" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Married Sisters</label>
                        <input type="number" className="form-control" name="married_sister" value={formData.married_sister} onChange={handleChange} min="0" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>
                    </div>
                  )}

                  {/* TAB 6: PARTNER PREFERENCES */}
                  {activeTab === "partner" && (
                    <div className="row g-3">
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Age From (Yrs)</label>
                        <input type="number" className="form-control" name="partner_age_from" value={formData.partner_age_from} onChange={handleChange} placeholder="e.g. 21" min="18" max="70" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Age To (Yrs)</label>
                        <input type="number" className="form-control" name="partner_age_to" value={formData.partner_age_to} onChange={handleChange} placeholder="e.g. 28" min="18" max="70" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Height From</label>
                        <select className="form-control" name="partner_height_from" value={formData.partner_height_from} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Height From</option>
                          {heightOptions.map(h => (
                            <option key={h.value} value={h.value}>{h.label}</option>
                          ))}
                          {formData.partner_height_from && !heightOptions.some(h => String(h.value) === String(formData.partner_height_from)) && (
                            <option value={formData.partner_height_from}>{formData.partner_height_from}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-3 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Height To</label>
                        <select className="form-control" name="partner_height_to" value={formData.partner_height_to} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Height To</option>
                          {heightOptions.map(h => (
                            <option key={h.value} value={h.value}>{h.label}</option>
                          ))}
                          {formData.partner_height_to && !heightOptions.some(h => String(h.value) === String(formData.partner_height_to)) && (
                            <option value={formData.partner_height_to}>{formData.partner_height_to}</option>
                          )}
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Marital Status</label>
                        <select className="form-control" name="partner_marital_status" value={formData.partner_marital_status} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Marital Status</option>
                          {maritalStatuses.map(m => <option key={m._id} value={m._id}>{m.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Religion</label>
                        <select className="form-control" name="partner_religion" value={formData.partner_religion} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Religion</option>
                          {religions.map(r => <option key={r._id} value={r._id}>{r.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Caste</label>
                        <select className="form-control" name="partner_caste" value={formData.partner_caste} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Caste</option>
                          {partnerCastes.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Sub Caste</label>
                        <select className="form-control" name="partner_sub_caste" value={formData.partner_sub_caste} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Sub Caste</option>
                          {partnerSubCastes.map(sc => <option key={sc._id} value={sc._id}>{sc.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Mother Tongue</label>
                        <select className="form-control" name="partner_mother_tongue" value={formData.partner_mother_tongue} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Mother Tongue</option>
                          {languages.map(l => <option key={l._id} value={l._id}>{l.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Diet</label>
                        <select className="form-control" name="partner_diet" value={formData.partner_diet} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Diet</option>
                          {diets.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner State</label>
                        <select className="form-control" name="partner_state" value={formData.partner_state} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any State</option>
                          {states.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner City</label>
                        <select className="form-control" name="partner_city" value={formData.partner_city} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any City</option>
                          {partnerCities.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Country</label>
                        <select className="form-control" name="partner_country" value={formData.partner_country} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Country</option>
                          {countries.map(cnt => <option key={cnt._id} value={cnt._id}>{cnt.name}</option>)}
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Education</label>
                        <select className="form-control" name="partner_education" value={formData.partner_education} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Education</option>
                          {degrees.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Occupation</label>
                        <select className="form-control" name="partner_occupation" value={formData.partner_occupation} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Occupation</option>
                          {occupations.map(o => <option key={o._id} value={o._id}>{o.name}</option>)}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Sector (Working With)</label>
                        <select className="form-control" name="partner_working_as" value={formData.partner_working_as} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Sector</option>
                          {workingWiths.map(w => <option key={w._id} value={w._id}>{w.name}</option>)}
                        </select>
                      </div>

                      <div className="col-md-6 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Income From</label>
                        <select className="form-control" name="partner_income_from" value={formData.partner_income_from} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Income From</option>
                          {partnerIncomeOptions.map(inc => (
                            <option key={inc.value} value={String(inc.value)}>{inc.label}</option>
                          ))}
                          {formData.partner_income_from && !partnerIncomeOptions.some(inc => String(inc.value) === String(formData.partner_income_from)) && (
                            <option value={formData.partner_income_from}>{formData.partner_income_from}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-6 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Income To</label>
                        <select className="form-control" name="partner_income_to" value={formData.partner_income_to} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Select Income To</option>
                          {partnerIncomeOptions.map(inc => (
                            <option key={inc.value} value={String(inc.value)}>{inc.label}</option>
                          ))}
                          {formData.partner_income_to && !partnerIncomeOptions.some(inc => String(inc.value) === String(formData.partner_income_to)) && (
                            <option value={formData.partner_income_to}>{formData.partner_income_to}</option>
                          )}
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Drinking Habit</label>
                        <select className="form-control" name="partner_drinking" value={formData.partner_drinking} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          {habitOptions.map(h => (
                            <option key={h} value={h}>{h}</option>
                          ))}
                          {formData.partner_drinking && !habitOptions.includes(formData.partner_drinking) && (
                            <option value={formData.partner_drinking}>{formData.partner_drinking}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Smoking Habit</label>
                        <select className="form-control" name="partner_smoking" value={formData.partner_smoking} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          {habitOptions.map(h => (
                            <option key={h} value={h}>{h}</option>
                          ))}
                          {formData.partner_smoking && !habitOptions.includes(formData.partner_smoking) && (
                            <option value={formData.partner_smoking}>{formData.partner_smoking}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Complexion</label>
                        <select className="form-control" name="partner_complexion" value={formData.partner_complexion} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Complexion</option>
                          {complexions.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Have Children</label>
                        <select className="form-control" name="partner_have_children" value={formData.partner_have_children} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          {haveChildrenOptions.map(hc => (
                            <option key={hc} value={hc}>{hc}</option>
                          ))}
                          {formData.partner_have_children && !haveChildrenOptions.includes(formData.partner_have_children) && (
                            <option value={formData.partner_have_children}>{formData.partner_have_children}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Family Type</label>
                        <select className="form-control" name="partner_family_type" value={formData.partner_family_type} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Family Type</option>
                          {familyTypeOptions.map(ft => (
                            <option key={ft} value={ft}>{ft}</option>
                          ))}
                          {formData.partner_family_type && !familyTypeOptions.includes(formData.partner_family_type) && (
                            <option value={formData.partner_family_type}>{formData.partner_family_type}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Family Value</label>
                        <select className="form-control" name="partner_family_value" value={formData.partner_family_value} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any Family Value</option>
                          {familyValueOptions.map(fv => (
                            <option key={fv} value={fv}>{fv}</option>
                          ))}
                          {formData.partner_family_value && !familyValueOptions.includes(formData.partner_family_value) && (
                            <option value={formData.partner_family_value}>{formData.partner_family_value}</option>
                          )}
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Partner Profile Managed By</label>
                        <select className="form-control" name="partner_managed_by" value={formData.partner_managed_by} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="">Any</option>
                          {partnerManagedByOptions.map(mb => (
                            <option key={mb} value={mb}>{mb}</option>
                          ))}
                          {formData.partner_managed_by && !partnerManagedByOptions.includes(formData.partner_managed_by) && (
                            <option value={formData.partner_managed_by}>{formData.partner_managed_by}</option>
                          )}
                        </select>
                      </div>
                    </div>
                  )}

                  {/* TAB 7: PHOTOS MANAGEMENT */}
                  {activeTab === "photos" && (
                    <div className="row g-4">
                      <div className="col-12">
                        <div className="alert alert-info py-2" style={{ borderRadius: "8px", fontSize: "13px" }}>
                          <i className="fa fa-info-circle me-1"></i> Admin can upload, replace, or delete member photos. Files are automatically uploaded to Cloudflare R2 storage.
                        </div>
                      </div>

                      {photoSlots.map((slot) => {
                        const currentPhoto = formData[slot.key];
                        const isUploading = uploadingPhotoIndex === slot.index;

                        return (
                          <div key={slot.key} className="col-md-4 col-sm-6">
                            <div
                              style={{
                                background: "#ffffff",
                                border: "1px solid #e2e8f0",
                                borderRadius: "12px",
                                padding: "15px",
                                textAlign: "center",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
                              }}
                            >
                              <span className="badge mb-2" style={{ background: slot.index === 0 ? "linear-gradient(135deg, #b82e66 0%, #8e1948 100%)" : "#475569", color: "#fff", padding: "5px 12px", borderRadius: "20px" }}>
                                {slot.label}
                              </span>

                              <div style={{ width: "100%", height: "200px", borderRadius: "8px", background: "#f8fafc", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", border: "1px dashed #cbd5e1", marginBottom: "12px" }}>
                                {currentPhoto ? (
                                  <img
                                    src={getImageUrl(currentPhoto)}
                                    alt={slot.label}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = "/assets/images/user.png";
                                    }}
                                  />
                                ) : (
                                  <div className="text-muted text-center p-3">
                                    <i className="fa fa-camera fa-2x mb-1" style={{ color: "#94a3b8" }}></i>
                                    <div style={{ fontSize: "12px" }}>No Photo Uploaded</div>
                                  </div>
                                )}
                              </div>

                              <div className="d-flex gap-2 justify-content-center">
                                <label
                                  className="btn btn-sm text-white m-0"
                                  style={{
                                    borderRadius: "20px",
                                    background: "#2563eb",
                                    fontSize: "12px",
                                    padding: "5px 14px",
                                    cursor: isUploading ? "not-allowed" : "pointer"
                                  }}
                                >
                                  {isUploading ? (
                                    <>
                                      <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                      Uploading...
                                    </>
                                  ) : (
                                    <>
                                      <i className="fa fa-upload me-1"></i> {currentPhoto ? "Replace" : "Upload"}
                                    </>
                                  )}
                                  <input
                                    type="file"
                                    accept="image/*"
                                    disabled={isUploading}
                                    style={{ display: "none" }}
                                    onChange={(e) => handlePhotoUpload(e, slot.key, slot.index)}
                                  />
                                </label>

                                {currentPhoto && (
                                  <button
                                    type="button"
                                    onClick={() => handlePhotoDelete(slot.key, slot.index)}
                                    className="btn btn-sm btn-danger"
                                    style={{ borderRadius: "20px", fontSize: "12px", padding: "5px 14px" }}
                                  >
                                    <i className="fa fa-trash me-1"></i> Delete
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* TAB 8: ADMIN & CONTROLS */}
                  {activeTab === "admin" && (
                    <div className="row g-3">
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Account Status</label>
                        <select className="form-control" name="status" value={formData.status} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="Active">Active</option>
                          <option value="Deactive">Deactive / Suspended</option>
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Profile Approval Status</label>
                        <select className="form-control" name="profileApproval" value={formData.profileApproval} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="Approved">Approved</option>
                          <option value="Pending">Pending</option>
                          <option value="Rejected">Rejected</option>
                        </select>
                      </div>
                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Photo Approval Status</label>
                        <select className="form-control" name="photoApproval" value={formData.photoApproval} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="Approved">Approved</option>
                          <option value="Pending">Pending</option>
                          <option value="Rejected">Rejected</option>
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Document Approval Status</label>
                        <select className="form-control" name="documentApproval" value={formData.documentApproval} onChange={handleChange} style={{ borderRadius: "8px", padding: "8px 12px" }}>
                          <option value="Approved">Approved</option>
                          <option value="Pending">Pending</option>
                          <option value="Rejected">Rejected</option>
                        </select>
                      </div>

                      <div className="col-md-4 col-sm-6 form-group">
                        <label className="fw-bold text-dark">Registration Step</label>
                        <input type="number" className="form-control" name="step" value={formData.step ?? ""} onChange={handleChange} min="0" max="11" style={{ borderRadius: "8px", padding: "8px 12px" }} />
                        <small className="text-muted">11 = Fully Registered Member</small>
                      </div>
                    </div>
                  )}

                  {/* Submit / Cancel Actions */}
                  <div className="ln_solid my-4" />
                  <div className="form-group text-end">
                    <Link to={`/user/view-member/${id}`} className="btn btn-sm me-2" style={{ borderRadius: "20px", background: "#ffffff", border: "1px solid #cbd5e1", color: "#475569", padding: "8px 22px", fontWeight: "600" }}>
                      Cancel
                    </Link>
                    <button
                      type="submit"
                      className="btn btn-sm text-white"
                      style={{ borderRadius: "20px", background: "linear-gradient(135deg, #b82e66 0%, #8e1948 100%)", border: "none", fontWeight: "700", padding: "8px 28px", boxShadow: "0 4px 12px rgba(184,46,102,0.3)" }}
                      disabled={saving}
                    >
                      {saving ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          Saving Changes...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-check me-1"></i> Save Member Profile
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </div>
        <Footer />
      </div>
    </div>
  );
}
